import * as React from 'react';
import HistoricalFinancialsTable from './HistoricalFinancialsTable';

function HistoricalIncome({data} :any) {
  function incomeMetrics() : Array<any> {
    return [
      {
        displayName: 'Revenue',
        columnName: 'revenue',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Cogs',
        columnName: 'cogs',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Gross Profit',
        columnName: 'gross_profit',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Operating Income',
        columnName: 'operating_income_loss',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Operating Expenses',
        columnName: 'operating_expenses',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Income Before Taxes',
        columnName: 'income_before_taxes',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Net Income',
        columnName: 'net_income_loss',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'EPS Basic',
        columnName: 'eps_basic',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Outstanding Shares',
        columnName: 'wa_shares_o_basic',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Net Income Margin (%)',
        columnName: 'net_income_margin',
        className: 'net_income_margin_color',
        useHumanValue: false
      },
      {
        displayName: 'Gross Margin (%)',
        columnName: 'gross_margin',
        className: 'gross_margin_color',
        useHumanValue: false
      },
      {
        displayName: 'Operating Margin (%)',
        columnName: 'operating_margin',
        className: 'operating_margin_color',
        useHumanValue: false
      },
    ]
  }

  return (
    <div className="col-lg-12 grid-margin stretch-card">
      <div className="card financials-panel">
        <div className="card-body">
          <h4 className="card-title">Historical Income Financials</h4>
          <p className="card-description">
            Checking <strong>{data.company_name}</strong>'s margins is a good start to determine if <strong>{data.company_name}</strong> will make a good investment.
            A margin below 5% is low, higher than 10% is a healthy margin, and higher than 20% is a high margin. See the margins listed in the table below (The data is in {data.currency_symbol} currency):
          </p>
          <div className="table-responsive">
            <HistoricalFinancialsTable
              financialReport={data.financial_report}
              metricsDictionary={incomeMetrics()}
              numberOfYears={data.financial_report.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoricalIncome;
